<ion-header class="modal-header">
  <ion-toolbar>
    <div class="title-container">
      <div class="title">
        {{ config.title || ("contracts.title" | translate) }}
      </div>
      <div class="close" (click)="close()">
        <ion-icon name="dp-close"></ion-icon>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<div class="modal-content">
  <div class="container">
    <ng-container *ngIf="contracts.length === 0; else contractsList">
      <div class="empty-state">
        <ion-icon name="checkmark-circle-outline"></ion-icon>
        <p>{{ "province_contracts.all_signed" | translate }}</p>
      </div>
    </ng-container>

    <ng-template #contractsList>
      <div class="contracts-list">
        <div class="contract-item" *ngFor="let contract of contracts">
          <div class="contract-header">
            <div class="contract-info">
              <h3 class="contract-type">
                {{ getContractTypeLabel(contract.type) }}
              </h3>
              <div class="contract-meta">
                <span class="contract-version" *ngIf="contract.version">
                  {{ "contracts.version" | translate }}: {{ contract.version }}
                </span>
                <span class="contract-date" *ngIf="contract.activationDate">
                  {{ "contracts.activated" | translate }}:
                  {{ formatDate(contract.activationDate) }}
                </span>
              </div>
            </div>
            <ion-button
              [disabled]="signingContractIds.has(contract.id)"
              (click)="signContract(contract)"
              class="sign-button"
              fill="outline"
              size="small"
            >
              <ion-icon name="create-outline" slot="start"></ion-icon>
              <span *ngIf="!signingContractIds.has(contract.id)">{{
                "contracts.sign" | translate
              }}</span>
              <span *ngIf="signingContractIds.has(contract.id)">{{
                "contracts.signing" | translate
              }}</span>
            </ion-button>
          </div>

          <div class="contract-footer" *ngIf="contract.pdfUrl">
            <div class="footer-buttons">
              <ion-button
                fill="outline"
                size="small"
                (click)="openPdf(contract.pdfUrl)"
                class="action-button view-pdf-button"
              >
                <ion-icon name="document-outline" slot="start"></ion-icon>
                {{ "contracts.view_pdf" | translate }}
              </ion-button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
